
import React from 'react';
type JobTitle = {
  isAudioSource?: boolean;
  title: string;
}

 
export const JobTitle = ({ isAudioSource, title }: JobTitle) => {
  if (isAudioSource)
    return (<span title={title}>&#x1F3B6; {title}</span>)
  return <span title={title}> {title} </span>;
}